module.exports = __webpack_public_path__ + "img/off.0e2ad907.webp";